import { Entity } from '@core/entities/entity'
import { ITaskAuditResultMetadata } from './ITaskAuditResultMetadata'
import { plainToInstance, Type } from 'class-transformer'
import { TaskTemplateRole } from '@core/entities/task/TaskTemplateRole'
import { User } from '@core/entities/user'
import { TaskStep } from '@core/entities/task/TaskStep'
import { TaskStatus } from '@core/entities/task/TaskBase'
import { TaskTemplatePriorityType } from '@core/entities/task/TaskTemplateProperties'
import moment from 'moment/moment'

export class TaskAuditResultMetadata extends Entity<ITaskAuditResultMetadata> {
  summary: string

  @Type(() => TaskTemplateRole)
  assignedToRole: TaskTemplateRole

  @Type(() => User)
  assigneeUser: User

  @Type(() => TaskStep)
  currentStep: TaskStep

  dueDate: string

  priority: TaskTemplatePriorityType

  status: TaskStatus

  @Type(() => TaskStep)
  stepData: TaskStep

  public isOverdue(): boolean {
    return (
      moment().isAfter(this.dueDate) &&
      !['DONE', 'CANCELLED'].includes(this.status)
    )
  }

  public static new(payload: unknown): TaskAuditResultMetadata {
    const entity = plainToInstance(TaskAuditResultMetadata, payload)

    return entity
  }
}
